import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../Helper/Helper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function InfoDuoBoxDesign() {
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setIsLoading(false);
    setFacilitiesData(response?.data);
  };

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Our Facilities" Image="theme-2-banner-facilities.webp"/>

        <div className="container">
          <div className="row mt-5">
            <div className="offset-md-2 col-md-8">
              <div className="title-wrap text-center">
                <div className="section-title margin-bottom-60">
                  <h2 className="section-title mb-0 text-uppercase">
                    Provides Our{" "}
                    <span className="theme-color">Best Facilities</span>
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {isLoading ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <Spinner />
              </div>
            ) : facilitiesData?.length === 0 ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <h4>No Record Available</h4>
              </div>
            ) : (
              facilitiesData?.map((data, index) => (
                <div key={index} className="col-lg-4 mb-5">
                  <div className="feature-box-wrap f-box-style-6 relative duo-box-home-height">
                    <div className="feature-box-details h-100">
                      <div className="feature-img">
                        <img
                          className="img-fluid"
                          src={data?.facility_image}
                          style={{ height: "auto" }}
                          alt="feature img"
                        />
                      </div>
                      <div className="feature-content mt-4 mb-3">
                        <div className="feature-title relative margin-bottom-5">
                          <h5>
                            {" "}
                            <Link
                              to={`/facility/${data?.facility_slug
                                ?.replaceAll(" ", "-")
                                ?.replaceAll("/", "-")}`}
                            >
                              {data?.facility_title}
                            </Link>
                          </h5>
                        </div>
                        <p

                          className="mb-0 facilities-listing-1"
                          dangerouslySetInnerHTML={{
                            __html:
                              limitParagraphByCharLimit(data?.facility_short_description, 70) +
                              (data?.facility_short_description?.length > 70 ? "..." : ""),
                          }}
                        />
                      </div>
                      <div className="button">
                        <Link
                          className="btn-link"
                          to={`/facility/${data?.facility_slug
                            ?.replaceAll(" ", "-")
                            ?.replaceAll("/", "-")}`}
                        >
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default InfoDuoBoxDesign;
